import React from 'react';

const About = () => {
    return (
        <div>
            <h1 className='text-4xl mt-12 text-center'>ধন্যবাদ টিম প্রোগ্রামিং হিরো</h1>
            <h1 className='text-2xl mt-12 text-center'>স্পেশালী কম টাকায় প্রোগ্রামার বানানোর কারিগর ঝং-ঝংআকর (ঝংকর) ভাইয়ার প্রতি কৃতজ্ঞা ও ভালোবাসা</h1>
            <h1 className='text-4xl mt-12 text-center'>নোয়াখাইল্লা ডেভেলপার</h1>
        </div>
    );
};

export default About;